import { IRoute } from '../interfaces';
import { lazyWithRetry } from '../utils/lazyWithRetry';
import {
  AssignmentOutlined,
  AttachMoney,
  CloudUpload as CloudUploadIcon,
  CrisisAlertOutlined,
  HomeOutlined,
  HomeWorkOutlined,
  Link,
  ListAlt,
  ListAltOutlined,
  PeopleOutline,
  PriceChangeOutlined,
  Radar,
  SmartToy,
  DraftsOutlined,
  VideocamOutlined,
  PriceCheckOutlined,
  RequestQuoteOutlined,
  SchoolOutlined,
  SearchOutlined,
  SellOutlined,
  Settings,
  SpaceDashboard,
  TaskAlt as TaskAltIcon,
  Calculate,
  MapOutlined,
} from '@mui/icons-material';

// Lazy load the components with retry logic
const HomeWrapper = lazyWithRetry(() => import('../pages/Home/HomeWrapper'));
const HowItWorks = lazyWithRetry(
  () => import('../pages/HowItWorks/HowItWorks')
);
const SellingDasboard = lazyWithRetry(
  () => import('../pages/Dashboard/Selling/SellerDashboard')
);
const BuyingDashboard = lazyWithRetry(
  () => import('../pages/Dashboard/Buying/BuyerDashboard')
);
const CreateListing = lazyWithRetry(
  () => import('../pages/EditListing/EditListing')
);
const Listing = lazyWithRetry(() => import('../pages/Listings/Listing'));
const Detail = lazyWithRetry(() => import('../pages/Detail/Detail'));
const Offers = lazyWithRetry(() => import('../pages/Offers/Offers'));
const SettingsPage = lazyWithRetry(() => import('../pages/Settings/Settings'));
const Customers = lazyWithRetry(
  () => import('../pages/Admin/Customers/Customers')
);
const ClientDetailView = lazyWithRetry(
  () => import('../pages/Admin/Customers/ClientDetailView')
);
const Comps = lazyWithRetry(() => import('../pages/Admin/Comps/Comps'));
const CmaWorkspace = lazyWithRetry(() => import('../pages/Admin/CmaWorkspace/CmaWorkspace'));
const AgentApprovalsRedirect = lazyWithRetry(
  () => import('../pages/Admin/AgentApprovalsRedirect')
);
const Escalations = lazyWithRetry(
  () => import('../pages/Admin/Escalations/Escalations')
);
const ReviewQueue = lazyWithRetry(() => import('../pages/Admin/ReviewQueue/ReviewQueue'));
const TestimonialsReview = lazyWithRetry(
  () => import('../pages/Admin/Testimonials/TestimonialsReview')
);
const CommandCenter = lazyWithRetry(
  () => import('../pages/Admin/CommandCenter/CommandCenter')
);
const PriceOpinion = lazyWithRetry(
  () => import('../pages/PriceOpinion/PriceOpinion')
);
const Listings = lazyWithRetry(
  () => import('../pages/Admin/Listings/Listings')
);
const ShortURLRedirect = lazyWithRetry(
  () => import('../components/ShortURLRedirect/ShortURLRedirect')
);
const TransactionDashboard = lazyWithRetry(
  () => import('../pages/Transactions/TransactionDashboard')
);
const ListingBySlug = lazyWithRetry(
  () => import('../pages/Listings/ListingBySlug')
);
const ShowingSurvey = lazyWithRetry(
  () => import('../pages/ShowingSurvey/ShowingSurvey')
);
const TourWalkthrough = lazyWithRetry(
  () => import('../pages/TourWalkthrough/TourWalkthrough')
);
const PBuyerDashboard = lazyWithRetry(
  () => import('../pages/Dashboard/PBuying/PBuyerDashboard')
);
const BuyerPrep = lazyWithRetry(
  () => import('../components/BuyerPrep/BuyerPrep')
);
const BrowseProperties = lazyWithRetry(
  () => import('../pages/BrowseProperties/BrowseProperties')
);
const LakeBrowse = lazyWithRetry(() => import('../pages/LakeBrowse/LakeBrowse'));
const LeadUpload = lazyWithRetry(
  () => import('../pages/Admin/LeadUpload/LeadUpload')
);
const AdminTransactions = lazyWithRetry(
  () => import('../pages/Admin/Transactions/Transactions')
);
const TasksRedirect = lazyWithRetry(
  () => import('../pages/Admin/TasksRedirect')
);
const InvestorLeadsPage = lazyWithRetry(
  () => import('../pages/Admin/InvestorLeads/InvestorLeads')
);
const TodayHub = lazyWithRetry(
  () => import('../pages/Admin/TodayHub/TodayHub')
);
const PricingCalculator = lazyWithRetry(
  () => import('../pages/Admin/PricingCalculator/PricingCalculator')
);
export const routes: Array<IRoute> = [
  {
    key: 'home',
    title: 'Home',
    path: '/home',
    enabled: true,
    component: HomeWrapper,
    icon: HomeOutlined,
    menu: true,
    protected: true,
    sellerOnly: false,
  },
  {
    key: 'how-it-works',
    title: 'How it works',
    path: '/how-it-works',
    enabled: true,
    component: HowItWorks,
    icon: MapOutlined,
    menu: false,
    protected: true,
  },
  {
    key: 'academy',
    title: 'Academy',
    path: '/academy',
    enabled: true,
    component: BuyerPrep,
    icon: SchoolOutlined,
    menu: false,
    protected: true,
  },
  {
    key: 'browse-properties',
    title: 'Browse Properties',
    path: '/browse',
    enabled: true,
    component: BrowseProperties,
    icon: SearchOutlined,
    menu: true,
    protected: false,
    sellerOnly: false,
  },
  {
    key: 'lake-browse',
    title: 'Lake Search',
    path: '/lakes',
    enabled: true,
    component: LakeBrowse,
    icon: SearchOutlined,
    menu: false,
    protected: false,
    sellerOnly: false,
  },
  {
    key: 'selling-route',
    title: 'Selling',
    path: '/selling',
    enabled: true,
    component: SellingDasboard,
    icon: SellOutlined,
    menu: true,
    protected: true,
    sellerOnly: true,
  },
  {
    key: 'selling-route',
    title: 'Selling',
    path: '/selling',
    enabled: true,
    component: SellingDasboard,
    icon: SellOutlined,
    menu: true,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'buying-route',
    title: 'Buying',
    path: '/buying',
    enabled: true,
    component: BuyingDashboard,
    icon: HomeWorkOutlined,
    menu: true,
    protected: true,
    sellerOnly: true,
  },
  {
    key: 'edit-listing-route',
    title: 'Edit Listing',
    path: '/listings/:id/edit',
    enabled: true,
    component: CreateListing,
    icon: SpaceDashboard,
    menu: false,
    protected: true,
    sellerOnly: true,
  },
  {
    key: 'buyer-detail-route',
    title: '',
    path: '/buyers/:id/listing/:listingId',
    enabled: true,
    component: Detail,
    icon: ListAlt,
    menu: false,
    protected: true,
    sellerOnly: false,
  },
  {
    key: 'admin-buyer-detail-route',
    title: '',
    path: '/admin/buyers/:id/listing/:listingId',
    enabled: true,
    component: Detail,
    icon: ListAlt,
    menu: false,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'listing-route',
    title: 'Listing',
    path: '/listings/:id',
    enabled: true,
    component: Listing,
    icon: ListAlt,
    menu: false,
    protected: false,
  },
  {
    key: 'offers-route',
    title: 'Offers',
    path: '/offers',
    enabled: true,
    component: Offers,
    icon: RequestQuoteOutlined,
    menu: true,
    protected: true,
    sellerOnly: true,
  },
  {
    key: 'admin-dashboard',
    title: 'Today',
    path: '/admin',
    enabled: true,
    component: TodayHub,
    icon: SpaceDashboard,
    menu: true,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'customers-admin',
    title: 'Clients',
    path: '/admin/customers',
    enabled: true,
    component: Customers,
    icon: PeopleOutline,
    menu: true,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'customer-detail-admin',
    title: 'Client Detail',
    path: '/admin/customers/:id',
    enabled: true,
    component: ClientDetailView,
    icon: PeopleOutline,
    menu: false,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'listings-admin',
    title: 'Listings',
    path: '/admin/listings',
    enabled: true,
    component: Listings,
    icon: ListAltOutlined,
    menu: true,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'transactions-admin',
    title: 'Transactions',
    path: '/admin/transactions',
    enabled: true,
    component: AdminTransactions,
    icon: AssignmentOutlined,
    menu: true,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'cma-workspace-admin', title: 'CMA workspace', path: '/admin/cma',
    enabled: true, component: CmaWorkspace, icon: PriceCheckOutlined,
    menu: true, protected: true, adminOnly: true,
  },
  {
    key: 'comps-admin',
    title: 'Comps',
    path: '/admin/comps',
    enabled: true,
    component: Comps,
    icon: PriceCheckOutlined,
    menu: true,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'price-opinion-route',
    title: 'Price Opinion',
    path: '/price-opinion/:id',
    icon: PriceChangeOutlined,
    enabled: true,
    component: PriceOpinion,
    menu: false,
    protected: true,
    sellerOnly: true,
  },
  {
    key: 'short-url-redirect',
    title: 'Short URL Redirect',
    path: '/s/:id',
    enabled: true,
    component: ShortURLRedirect,
    menu: false,
    protected: false,
    icon: Link,
  },
  {
    key: 'transaction-route',
    title: 'Transaction',
    path: '/transactions/:id',
    enabled: true,
    component: TransactionDashboard,
    icon: ListAlt,
    menu: false,
    protected: true,
    sellerOnly: false,
  },
  {
    key: 'listing-by-slug-route',
    title: 'Listing',
    path: '/:listingSlug',
    enabled: true,
    component: ListingBySlug,
    icon: ListAlt,
    menu: false,
    protected: false,
  },
  {
    key: 'lead-upload-admin',
    title: 'Lead Upload',
    path: '/admin/lead-upload',
    enabled: true,
    component: LeadUpload,
    icon: CloudUploadIcon,
    menu: false,
    protected: true,
    adminOnly: true,
  },
  {
    // Deprecated: the standalone tasks list moved into the unified task
    // inbox on `/admin`. The route stays only so the old URL redirects
    // instead of 404ing.
    key: 'tasks-admin',
    title: 'Tasks',
    path: '/admin/tasks',
    enabled: true,
    component: TasksRedirect,
    icon: TaskAltIcon,
    menu: false,
    protected: true,
    adminOnly: true,
  },
  {
    // Deprecated: approvals moved into the unified task inbox on `/admin`.
    // The route stays only so the old URL redirects instead of 404ing.
    key: 'agent-approvals-admin',
    title: 'Agent Approvals',
    path: '/admin/agent-approvals',
    enabled: true,
    component: AgentApprovalsRedirect,
    icon: SmartToy,
    menu: false,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'escalations-admin',
    title: 'Escalations',
    path: '/admin/escalations',
    enabled: true,
    component: Escalations,
    icon: CrisisAlertOutlined,
    menu: true,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'review-queue-admin',
    title: 'Review Queue',
    path: '/admin/review-queue',
    enabled: true,
    component: ReviewQueue,
    icon: DraftsOutlined,
    menu: true,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'testimonials-admin',
    title: 'Testimonials',
    path: '/admin/testimonials',
    enabled: true,
    component: TestimonialsReview,
    icon: VideocamOutlined,
    menu: true,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'command-center-admin',
    title: 'Command Center',
    path: '/admin/command-center',
    enabled: true,
    component: CommandCenter,
    icon: Radar,
    menu: false,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'investor-leads-admin',
    title: 'Investor Leads',
    path: '/admin/investor-leads',
    enabled: true,
    component: InvestorLeadsPage,
    icon: PeopleOutline,
    menu: false,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'pricing-calculator-admin',
    title: 'Pricing Calculator',
    path: '/admin/pricing-calculator',
    enabled: true,
    component: PricingCalculator,
    icon: Calculate,
    menu: true,
    protected: true,
    adminOnly: true,
  },
  {
    key: 'settings-route',
    title: 'Settings',
    path: '/settings',
    enabled: true,
    component: SettingsPage,
    icon: Settings,
    menu: true,
    protected: true,
    sellerOnly: false,
  },
  {
    key: 'showing-survey-route',
    title: 'Showing Survey',
    path: '/showing-survey/:id',
    enabled: true,
    component: ShowingSurvey,
    icon: AssignmentOutlined,
    menu: false,
    protected: false,
  },
  {
    key: 'tour-walkthrough-route',
    title: 'Tour Walkthrough',
    path: '/buying/walkthrough/:showingId',
    enabled: true,
    component: TourWalkthrough,
    icon: AssignmentOutlined,
    menu: false,
    protected: false,
  },
  {
    key: 'pbuyer-dashboard-route',
    title: 'PBuyer Dashboard',
    path: '/pbuyer',
    enabled: true,
    component: PBuyerDashboard,
    icon: HomeOutlined,
    menu: false,
    protected: true,
    sellerOnly: false,
  },
  {
    key: 'offer-portal-route',
    title: 'Offer Portal',
    path: '/offer-portal/:token',
    enabled: true,
    component: Detail,
    icon: AttachMoney,
    menu: false,
    protected: false, // Public access with token
    sellerOnly: false,
  },
];
